module.exports = __webpack_public_path__ + "img/layout_04_hover.e2c8d75c.svg";